var login_form = document.querySelector('.login-form');
var recover_form =  document.querySelector('.recover-form');
if(login_form &&  recover_form){
  var contact_area = document.querySelector(".drawer-back-login");
  var account_reg_area = document.querySelector(".account-register-url");
  var account_login_area = document.querySelector(".customer-login-drawer");
  if (contact_area != null){
    contact_area.addEventListener('click',function(e){
      e.preventDefault();
      login_form.classList.remove('hide-form');
      recover_form.classList.add('hide-form');
      document.querySelector('.login-page-title').classList.remove('hide-form');
      document.querySelector('.reset-password-title').classList.add('hide-form');
      contact_area.classList.add('hide-form');
    });
  }
  document.querySelector('.enable-login').addEventListener('click',function(e){
    e.preventDefault();
    login_form.classList.remove('hide-form');
    recover_form.classList.add('hide-form');
    if (document.querySelector('.login-page-title') != null){
      document.querySelector('.login-page-title').classList.remove('hide-form');
    }
    if (document.querySelector('.reset-password-title') != null){
      document.querySelector('.reset-password-title').classList.add('hide-form');
    }
    if (contact_area != null){
      contact_area.classList.add('hide-form');
    }
  });
  if(document.querySelector('.enable-forgot')){
  document.querySelector('.enable-forgot').addEventListener('click',function(e){
    e.preventDefault();
    login_form.classList.add('hide-form');
    recover_form.classList.remove('hide-form');
    if (document.querySelector('.login-page-title') != null){
      document.querySelector('.login-page-title').classList.add('hide-form');
    }
    if (document.querySelector('.reset-password-title') != null){
      document.querySelector('.reset-password-title').classList.remove('hide-form');
    }
    if (contact_area != null){
      contact_area.classList.remove('hide-form');
    }
  });
}
  if (account_reg_area != null){
    account_reg_area.addEventListener('click',function(e){
      e.preventDefault();
      login_form.classList.add('hide-form');
      recover_form.classList.add('hide-form');
      document.querySelector('.login-page-title').classList.add('hide-form');
      document.querySelector('.reset-password-title').classList.add('hide-form');
      document.querySelector('.reg-title').classList.remove('hide-form');
      document.querySelector('.login-svg-icon-back').classList.remove('hide-form');
      document.querySelector('.ac-reg-sidebar').classList.remove('hide-form');
    });
  }
  
  function close_login() {
    login_form.classList.remove('hide-form');
    recover_form.classList.add('hide-form');
    document.querySelector('.login-page-title').classList.remove('hide-form');
    document.querySelector('.reset-password-title').classList.add('hide-form');
    document.querySelector('.reg-title').classList.add('hide-form');
    document.querySelector('.login-svg-icon-back').classList.add('hide-form');
    document.querySelector('.ac-reg-sidebar').classList.add('hide-form');
  }
  
  if (document.querySelector(".drawer-close") != null){
    document.querySelector(".drawer-close").addEventListener('click',function(e){
      e.preventDefault();
      close_login()
    });
  }
  document.querySelector('.overlay-box').addEventListener('click',function(e){
    e.preventDefault();
    close_login()
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const isNotCombinedKey = !(event.ctrlKey || event.altKey || event.shiftKey);
      if (isNotCombinedKey) {
        event.preventDefault();
        close_login()
      }
    }
  });
  if (account_login_area != null){
    account_login_area.addEventListener('click',function(e){
      e.preventDefault();
      close_login()
    });
  }
}

if(document.querySelector('.open-order-details')){
  document.querySelector('.open-order-details').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('.account-left').classList.add('account-page-active');
    document.querySelector('.account-right').classList.remove('account-page-active');
  });
}
window.addEventListener("resize", function() {
  if(document.querySelector('.open-order-details')){
    document.querySelector('.open-order-details').addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('.account-left').classList.add('account-page-active');
      document.querySelector('.account-right').classList.remove('account-page-active');
    });
  }
});

if(document.querySelector('.edit-address-button')){
  document.querySelectorAll('.edit-address-button').forEach(function(editbutton){
    editbutton.addEventListener('click',function(e){
      e.preventDefault();
      var address_id = this.dataset.addressid;
      document.querySelectorAll('.address-edit-form').forEach(function(editformdiv){
        if(editformdiv.classList.contains('active-form') && editformdiv.dataset.id != address_id){
          editformdiv.classList.remove('active-form');
        }
      });
      document.querySelector('[data-id="'+address_id+'"]').classList.toggle('active-form');
      document.querySelector('.add-address-form').classList.remove('d-lg-block');
      document.querySelector('.edit-address-form').classList.remove('hide-form');
      document.querySelector('.address--list--outer').classList.add('hide-form');
      document.querySelector('.add-address-form').classList.add('hide-form');
      document.querySelector('.border-bottom-colour').classList.add('hide-form');
      document.querySelector('.account-order-title').classList.add('hide-form');
      var data_val = document.querySelector('.accordionItem.open .address-list-title').innerHTML;
      document.querySelector('.account-order-title').innerText = "Edit: "+ data_val +"";
        
    });
  });
}

if(document.querySelector('#AddressCountryNew')){
  new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
    hideElement: 'AddressProvinceContainerNew'
  });
  document.querySelectorAll('[data-address-country-select]').forEach((select) => {
    const formId = select.dataset.formId;
    new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
      hideElement: `AddressProvinceContainer_${formId}`
    });
  });
}

document.querySelectorAll('.destroy_button').forEach(function(destroyButton){
  destroyButton.addEventListener('click',function(e){
    var destroyId = this.dataset.destroy;
    console.log(destroyId);
    Shopify.postLink(
      '/account/addresses/'+destroyId, 
      {'parameters': {'_method': 'delete'}}
    );
  });
});

if(document.querySelector('.account-link')){
  document.querySelector('.account-link').addEventListener('click',function(e){
    document.querySelector('.account-page-active').classList.add('active');
    document.querySelector('.account-left').style.display = 'none';
  });
}

if(document.querySelector('.add-address')){
  document.querySelector('.add-address').addEventListener('click',function(e){
    document.getElementById('address_form_new').classList.toggle('active-open-form');
    document.querySelector('.add-address-form').classList.remove('d-lg-block');
    document.querySelector('.edit-address-form').classList.add('hide-form');
    document.querySelector('.address--list--outer').classList.add('hide-form');
    document.querySelector('.add-address-form').classList.add('hide-form');
    document.querySelector('.border-bottom-colour').classList.add('hide-form');
    document.querySelector('.account-new-address').classList.remove('hide-form');
    document.querySelector('.account-order-title').classList.add('hide-form');
  });
}

if (window.matchMedia("(max-width: 991px)").matches) {

  function address_show_mobile () {
    document.querySelector('.account-order-title').classList.remove('hide-form');
    document.querySelector('.address--list--outer').classList.remove('hide-form');
    document.querySelector('.account-new-address').classList.add('hide-form');
    document.querySelectorAll('.address-edit-form').forEach(function(editformdivs){
      if(editformdivs.classList.contains('active-form')){
        editformdivs.classList.remove('active-form');
      }
    });
  }
  
  document.querySelectorAll('.close-popup-products-edit').forEach(function(closeButton){
    closeButton.addEventListener('click',function(e){
      address_show_mobile ()
    });
  });
  
  if(document.querySelector('.close-popup-products')){
    document.querySelector('.close-popup-products').addEventListener('click',function(e){
      address_show_mobile ()
    });
  }
  
}
if (window.matchMedia("(max-width: 575px)").matches) {
  document.querySelector('.login-svg-icon-back').addEventListener('click',function(e){
    e.preventDefault();
    close_login()
  });
}

// Defining a function to display error message 
function printError(elemId, hintMsg) {
    document.getElementById(elemId).innerHTML = hintMsg;
 
}

// Defining a function to validate form 
function validateForm() {
    // Retrieving the values of form elements 
    var email = document.querySelector('#email');
    var password = document.querySelector('#password');
    var confirm_password = document.querySelector('#repeat-password');
    var country = document.querySelector('#AddressCountryNew');
    var f_name = document.querySelector('#FirstName');
    var l_name = document.querySelector('#Surname');
    var add_f_name = document.querySelector('#AddressFirstNameNew');
    var add_l_name = document.querySelector('#AddressLastNameNew');
    var zip_code = document.querySelector('#AddressZipNew');
    var hus_number = document.querySelector('#house-number');
    var city = document.querySelector('#AddressCityNew');
    var house = document.querySelector('#AddressAddress1New');
    var dob = document.querySelector('#DOB');
    
	// Defining error variables with a default value
    var nameErr = emailErr = passwordErr = confirm_passwordErr = countryErr = zip_codeErr = cityErr = houseErr = f_nameErr = l_nameErr = add_f_nameErr = add_l_nameErr = hus_numberErr = dobErr = false;
    
    // Validate email address
  if(email != null){
    if(email == "") {
        printError("emailErr", "Please enter your email address");
       emailErr = true;
    } else {
        // Regular expression for basic email validation
        var regex = /^\S+@\S+\.\S+$/;
        if(regex.test(email.value) === false) {
            printError("emailErr", "Please enter a valid email address");
        } else{
            printError("emailErr", "");
            emailErr = false;
        }
    }
}
    // Validate password
  if(password != null){
    if(password == "") {
        printError("passwordErr", "Please enter Password");
      passwordErr = true;
    } else {
        printError("passwordErr", "");
        passwordErr = false;
    }
  }

    // Validate Confirm Password
  if(confirm_password != null){
    if(confirm_password == "") {
        printError("confirm_passwordErr", "Please enter Repeat Password");
      passwordErr = true;
    } else {
      if(password.value != confirm_password.value) {
        printError("confirm_passwordErr", "Repeat Password not matched with Password");
      } else {
        printError("confirm_passwordErr", "");
        confirm_passwordErr = false;
      }
    }
  }
  
    // Validate name
  if(f_name != null){
    if(f_name.value == "") {
        printError("f_nameErr", "Please enter your name");
      f_nameErr = true;
    } else {
      
            printError("f_nameErr", "");
            f_nameErr = false;
       
    }
  }
  if(l_name != null) {
    if(l_name.value == "") {
        printError("l_nameErr", "Please enter your Surname");
       l_nameErr = true;
    } else {
  
            printError("l_nameErr", "");
            l_nameErr = false;
       
    }
  }
    // Validate name
  if(add_f_name != null){
    if(add_f_name.value == "") {
        printError("add_f_nameErr", "Please enter your name");
       add_f_nameErr = true;
    } else {
       
            printError("add_f_nameErr", "");
            add_f_nameErr = false;
       
    }
    }

  if(add_l_name != null ){
    if(add_l_name.value == "") {
        printError("add_l_nameErr", "Please enter your Surname");
       add_l_nameErr = true;
    } else {
   
            printError("add_l_nameErr", "");
            add_l_nameErr = false;
       
    }
    }
    
    // Validate country
  if(country != null ){
    if(country.value == "---") {
        printError("countryErr", "Please select your country");
      countryErr = true;
    } else {
        printError("countryErr", "");
        countryErr = false;
    }
  }
    
    // Postal code
  if(zip_code != null ){
    if(zip_code.value == "") {
        printError("zip_codeErr", "Please Enter Postal code");
       zip_codeErr = true;
    } else {
        printError("zip_codeErr", "");
        zip_codeErr = false;
    }
  }

  
    // House Number
  if(hus_number != null ){
    if(hus_number.value == "") {
        printError("hus_numberErr", "Please Enter House Number");
      hus_numberErr = true;
    } else {
        printError("hus_numberErr", "");
        hus_numberErr = false;
    }
  }
    
    // City
  if(city != null ){
    if(city.value == "") {
        printError("cityErr", "Please Enter City");
    } else {
        printError("cityErr", "");
        cityErr = false;
    }
  }
    
    // House Number
   if(house != null ){
    if(house.value == "") {
        printError("houseErr", "Please Enter House number");
      houseErr = true;
    } else {
        printError("houseErr", "");
        houseErr = false;
    }
   }
    
    // DOB
  if(dob != null ){
    if(dob.value == "") {
        printError("dobErr", "Please enter your mobile number");
      dobErr = false;
    } else {    
        printError("dobErr", "");
        dobErr = false;
    }
  }

    console.log(emailErr, passwordErr, confirm_passwordErr, countryErr, zip_codeErr, cityErr, houseErr, f_nameErr, l_nameErr, add_f_nameErr, add_l_nameErr, hus_numberErr, dobErr)
    // Prevent the form from being submitted if there are any errors
    if((emailErr || passwordErr || confirm_passwordErr || countryErr || zip_codeErr || cityErr || houseErr || f_nameErr || l_nameErr || add_f_nameErr || add_l_nameErr || hus_numberErr || dobErr) == true) {
       return false;
    }
};
